import '../applied_boolean_view.js.coffee'

Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.AppliedPageOwnerView extends Monitoring.Views.SocialContents.Filters.AppliedBooleanView
  unmodifiableByModerators: true

  initialize: ({searchQuery}) ->
    super(
      searchQuery: searchQuery
      title: I18n.t('monitoring.dashboard.filters.filter_names.page_owner.name')
      trueField: new Monitoring.Views.SocialContents.Filters.BooleanFilterViewField
        name: 'include_page_owner_generated'
        title: I18n.t('monitoring.dashboard.filters.filter_names.page_owner.include')
      falseField: new Monitoring.Views.SocialContents.Filters.BooleanFilterViewField
        name: 'exclude_page_owner_generated'
        title: I18n.t('monitoring.dashboard.filters.filter_names.page_owner.exclude')
    )
